import withLazyLoad from "../../utils/withLazyLoad";

const LazyVariantListReport = withLazyLoad(() => import('./VariantListReport'));
export default LazyVariantListReport;
